import { api } from './api';

export interface TutorCourse {
  id: number;
  name: string;
  status: string;
  registrationMethod?: string;
  courseType: string;
  board?: string;
  curriculumId?: number;
  curriculumSubjectId?: number;
  subjectName?: string;
  tutorId: number;
  createdAt?: string;
  deletedAt?: string | null;
  restoredAt?: string | null;
  enrolledStudentCount?: number | null;
  /** Non-null when an ACTIVE session exists for this course. */
  activeSessionId?: number | null;
}

export type ArchivedCourse = TutorCourse & { deletedAt: string };

export interface TutorCourseCreatePayload {
  name: string;
  curriculumId: number;
}

export const createCourse = async (name: string, curriculumId: number): Promise<TutorCourse> => {
  const response = await api.post('/api/tutor/courses', { name, curriculumId } as TutorCourseCreatePayload);
  return response.data.data;
};

export const getMyCourses = async (): Promise<TutorCourse[]> => {
  const response = await api.get('/api/tutor/courses');
  return response.data.data;
};

export const getCourse = async (id: number): Promise<TutorCourse> => {
  const response = await api.get(`/api/tutor/courses/${id}`);
  return response.data.data;
};

export const archiveCourse = async (id: number): Promise<void> => {
  await api.delete(`/api/tutor/courses/${id}`);
};

export const getArchivedCourses = async (): Promise<ArchivedCourse[]> => {
  const response = await api.get('/api/tutor/courses/archived');
  return response.data.data;
};

export const restoreCourse = async (id: number): Promise<TutorCourse> => {
  const response = await api.post(`/api/tutor/courses/${id}/restore`);
  return response.data.data;
};

export const publishCourse = async (id: number): Promise<TutorCourse> => {
  const response = await api.post(`/api/tutor/courses/${id}/publish`);
  return response.data.data;
};

// ─── Metrics ─────────────────────────────────────────────────────────────────

export interface TutorAtRiskStudent {
  studentId: number;
  displayName: string;
  enrolledAt: string;
  daysSinceEnrolment: number;
}

export interface TutorCourseSummaryMetrics {
  totalEnrolled: number;
  activeStudents: number;
  avgCompletionPct: number;
  completedStudents: number;
  atRiskStudents: TutorAtRiskStudent[];
}

export interface TutorCourseTopicMetrics {
  nodeId: number;
  nodeTitle: string;
  completedStudents: number;
  avgQuizScore: number | null;
  passRate: number | null;
}

export const getTutorCourseMetricsSummary = async (courseId: number): Promise<TutorCourseSummaryMetrics> => {
  const response = await api.get(`/api/tutor/courses/${courseId}/metrics`);
  return response.data.data;
};

export const getTutorCourseTopicMetrics = async (courseId: number): Promise<TutorCourseTopicMetrics[]> => {
  const response = await api.get(`/api/tutor/courses/${courseId}/metrics/topics`);
  return response.data.data;
};
